import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Button } from 'react-bulma-components';

interface IProps {
  children: React.ReactNode | HTMLElement;
  isDisabled: boolean;
  step: number;
  onReset: () => void;
}

class View extends Component<IProps> {
  render() {
    const { children, isDisabled, onReset, step } = this.props;

    return (
      <div className='content is-flex is-align-items-center is-justify-content-space-between'>
        <div className='is-flex is-align-items-center'>
          <span className='tag has-background-white mr-3 p-2 is-rounded has-border-1'>
            {step}
          </span>
          {children}
        </div>
        <Button disabled={isDisabled} size='small' onClick={onReset}>
          Reset
        </Button>
      </div>
    );
  }
}

const SectionHeader = observer(View);
export default SectionHeader;
